
// export const BASE_URL = `http://localhost:8000/api`

// export const IMAGE_URL = `http://localhost:8000/`
// export const BASE_URL = `https://ott-platform-eytt.onrender.com/api`

// export const IMAGE_URL = `https://ott-platform-eytt.onrender.com/`
// export const BASE_URL = `https://api.kalathiyainfotechapi.in/api`

// export const IMAGE_URL = `https://api.kalathiyainfotechapi.in/`
export const BASE_URL = `https://api.yoyokhel.com/api`

export const IMAGE_URL = `https://api.yoyokhel.com/`
